import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import theme from './theme';

// Admin Components
import ProtectedRoute from './components/Admin/ProtectedRoute';
import AdminLayout from './components/Admin/AdminLayout';

// Admin Pages
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import ManageTours from './pages/admin/ManageTours';
import ManageLocations from './pages/admin/ManageLocations';
import ManageServices from './pages/admin/ManageServices';
import ManageBookings from './pages/admin/ManageBookings';
import ManageOffers from './pages/admin/ManageOffers';
import ManageInquiries from './pages/admin/ManageInquiries';
import ManageCategories from './pages/admin/ManageCategories';
import ManageSubscribers from './pages/admin/ManageSubscribers';

const App = () => {
  useEffect(() => {
    document.title = process.env.REACT_APP_LOGO_TEXT || 'Sam Holidays';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Login Route */}
            <Route path="/login" element={<Login />} />

            {/* Redirect root to admin dashboard */}
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />

            {/* Admin Routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="tours" element={<ManageTours />} />
              <Route path="locations" element={<ManageLocations />} />
              <Route path="services" element={<ManageServices />} />
              <Route path="bookings" element={<ManageBookings />} />
              <Route path="offers" element={<ManageOffers />} />
              <Route path="inquiries" element={<ManageInquiries />} />
              <Route path="categories" element={<ManageCategories />} />
              <Route path="subscribers" element={<ManageSubscribers />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;